export const AspNetEmailValidationRegex = `\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*`;
export const AtLeast8CharsAndAtLeastOneNumberRegex = `^(?=.*\\d)[A-Za-z\\d]{8,}$`;
